import { useState, useEffect } from 'react';
import { Tabs, Space, Input, Divider, Badge, Select } from 'antd';
import Table from '../../../TableResizable';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import axios from 'axios';
import Utilisateur from '../../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Data from '../../../../Data/Data.json';
import SweetAlert from "sweetalert2";
import { Crypter } from '../../../../Functions/Security/Crypter';
import { Backdrop, Box, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from '@mui/material';
import ReformatDate from '../../../../Functions/Traitement/ReformatDate';
import { ColumnsType } from 'antd/es/table';
import Validation from '../../../../Models/Validation';
import ParamsPicklist from '../../../../Types/ParamsPicklist';
import SearchInput from '../../../SearchInput';
import DataHistoCpt from '../../../../Types/DataHistoCpt';
import formatNumber from '../../../../Functions/Traitement/FormatNumber';
import Hash from '../../../../Functions/Security/Hash';
import DataSelect from '../../../../Types/DataSelect';
import VerifDay from '../../../../Functions/Traitement/VerifDay';
import { useNavigate } from 'react-router-dom';

//const Swal = require('sweetalert2');
//let LinkSourceApi= require('../../Data/Data.json');

const ValideOperation = () => {
    // USER SESSION
    const auth = useAuthUser()
    const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

    // USER TOKEN
    const authHeader = useAuthHeader();

    //input de reacherche
    const { Search } = Input;

    const [form] = Form.useForm();
    const [formv] = Form.useForm();

    //const [formv] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

    const [SearchR, SetSearchR] = useState<string>("");
    const [, forceUpdate] = useState({});
    const [open, setOpen] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [ajoutActve, setAjoutActif] = useState(true);
    const [Modif, SetModif] = useState<any>("");
    const [ValTitle, SetValTitle] = useState<any>("");
    const [DataOperation, setDataOperation] = useState<DataHistoCpt[]>([]);
    const [Valider, Setvalide] = useState(true);
    const [User, SetUser] = useState<string>("");
    const [sbmit, setSbmit] = useState("add");
    const [start, setstart] = useState(false);
    const [Operation, SetOperation] = useState<DataSelect[]>();
    const Navigate = useNavigate();

    //parametre de recherche 

    let searchUser: ParamsPicklist = { CodeAgence: '', Table: "UTILIS", Colonne1: "CODUTI", Colonne2: "NOMUTI", Colagence: '101', Choix: 22 }
    
    const HandlerRest=()=>{
        formv.setFieldValue('Motpas','');
      }

    const handleValide = () => {
    //   // alert(e)
     if (form.getFieldValue("User")==="" || typeof form.getFieldValue("User") === 'undefined')
         { 
            SweetAlert.fire({ title: "Error", text: "Vous devez choisir un utilisateur avant de continuer ", icon: "error" }) 
            form.resetFields();
            return
         } 
         if (form.getFieldValue("User")===user.coduti ) 
         { 
            SweetAlert.fire({ title: "Error", text: "Impossible de valider une opération faite par vous", icon: "error" }) 
            form.resetFields();
            return
         } 

        if (typeof form.getFieldValue('reference') !== 'undefined' && form.getFieldValue('reference') !== '') {
            if (form.getFieldValue("TotalDebit") === form.getFieldValue("TotalCrebit")) {
            setSbmit("V");
            SetModif('');
            SetValTitle(<DialogTitle >Validation d'Opération </DialogTitle>);
            setOpen(true);
            }
            else  SweetAlert.fire({ title: "Validation Impossible écritures Déséquilibrées", text: ' Veuillez Vérifier les Opérations Saisies', icon: "error" })
        } else SweetAlert.fire({ title: "Warning", text: 'Veillez renseigné la réference', icon: "warning" })

    };

    const handRejet = () => {
        if (typeof form.getFieldValue('reference') !== 'undefined' && form.getFieldValue('reference') !== '') {
            SetValTitle(<DialogTitle >Rejet d'Opération </DialogTitle>);
            setSbmit("R");
            SetModif
                (
                    <Form.Item label="Motif du Rejet" rules={[{ required: true, message: "" }]} name="Motif">
                        <Input.TextArea />
                    </Form.Item>
                );
            setOpen(true);
        } else SweetAlert.fire({ title: "Warning", text: 'Veillez renseigné la réference', icon: "warning" })
    };

    useEffect(() => {
        forceUpdate({});
        if (start == false) {
            VerifDay(user.coduti, user.codage, authHeader, Navigate);
            setstart(true);
        }
        else {

        }
    }, []);

    function initialiazeButton() {
        Setvalide(true);
        Setvalide(true);
    }


    const columns: ColumnsType<DataHistoCpt> = [
        {
            title: 'DateOpe',
            dataIndex: 'DATOPE',
            ellipsis: true,
            width: 100,
            render: (text: any, reccord: any) => (
                <span>
                    {ReformatDate(text)}
                </span>
            )
        },
        {
            title: 'Heure',
            dataIndex: 'TIME',
            ellipsis: true,
            width: 100,
        },
        {
            title: 'N° Compte',
            dataIndex: 'NUMCPT',
            ellipsis: true,
            width: 200,
            filteredValue: [SearchR],
            onFilter: (value: any, record: any) => {
                return String(record.NUMCPT)
                    .toLowerCase()
                    .includes(value.toLowerCase()) ||
                    String(record.SENSEC)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.REPECE)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.MONTANT)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.LIBELL)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.Utilis)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.Motif)
                        .toLowerCase()
                        .includes(value.toLowerCase())
            }
        },
        {
            title: 'Sens',
            dataIndex: 'SENSEC',
            ellipsis: true,
            width: 100,
            align: 'center',
            render: (text: any, reccord: any) => (
                <Box sx={{ alignItems: 'center' }}  >
                    <Badge style={{ textAlign: 'center' }} status='success' color={reccord.SENSEC == "C" ? 'green' : reccord.SENSEC == "D" ? 'red' : 'orange'} size='default' count={reccord.SENSEC == "D" ? 'Debit' : reccord.SENSEC == "C" ? 'Credit' : 'No sence'}> </Badge>
                </Box>
            )
        },
        {
            title: 'Reférence',
            dataIndex: 'REPECE',
            ellipsis: true,
            width: 200,
        },
        {
            title: 'Montant',
            dataIndex: 'MONTANT',
            ellipsis: true,
            width: 150,
        },
        {
            title: 'Beneficiare',
            dataIndex: 'NBENEF',
            ellipsis: true,
            width: 200,
        },
        {
            title: 'Utisai',
            dataIndex: 'UTISAI',
            ellipsis: true,
            width: 100,
        },
        {
            title: 'Libelle',
            dataIndex: 'LIBELL',
            ellipsis: true,
            width: 200
        },
        {
            title: "",
            dataIndex: 'RelObject',
            width: 1
        }
    ];


    const HandleChangeUser = async () => {
        setLoading(true);
        form.setFieldsValue({ "TotalDebit": '', "TotalCrebit": '', "NbrCrebit": '', "Nbrdebit": '', "Solde": '' });
        setDataOperation([]);
        SetOperation([]);
        form.setFieldValue("reference", '');
        let CodeU = form.getFieldValue("User");
        SetUser(CodeU);

        var config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.GetOperation,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authHeader(),
                'CypherFilter': Crypter.encrypt('1'),
                'CypherCodeA': Crypter.encrypt(user.codage),
                'CypherCodeU': Crypter.encrypt(CodeU),
                'CypherRepec': Crypter.encrypt('')
            }
        };

        await
            axios(config)
                .then((response) => {
                    //alert('ok')
                    if (response.data) {
                        const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                        if (res.StatutCode == 200) {
                            let datas = res.Result;

                            const Datat: DataSelect[] = [];
                            if (datas.length === 0) {
                                //console.log("aucun élément ");
                            }
                            else {
                                res.Result.map((data: any, indice: number) => {
                                    Datat.push({ label: data.REPECE + "--" + data.UTISAI, value: data.REPECE });
                                })
                                SetOperation(Datat);
                            }
                        }
                    }
                    //  setLoad(false);
                }).catch((error) => {
                    SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
                })
        setLoading(false);
    }

    const HandlerChangReference = async (e: any) => {
       
        setLoading(true);
        setDataOperation([]);

        var data = { CodeAgence: "", Table: "ECPTAMPON", Colonne1: "REPECE", Colonne2: '', Colagence: '', Init: e, choix: 35 }
        var config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.AnySearch,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authHeader(),
                'CypherSearch': Crypter.encrypt(JSON.stringify(data))
            }
        };

        await
            axios(config)
                .then((response) => {
                    //alert('ok')
                    if (response.data) {
                        const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                        if (res.StatutCode == 200) {
                            let datas: [] = res.Result.Table;

                            const Datat: DataHistoCpt[] = [];
                            if (datas.length === 0) {
                                alert(JSON.stringify(res))
                                //console.log("aucun élément ");
                            }
                            else {
                                let TotalDebit: number = 0;
                                let TotalCrebit: number = 0;
                                let NbrCrebit: number = 0;
                                let Nbrdebit: number = 0;

                                res.Result.Table.map((data: any, indice: number) => {

                                    if (data.SENSEC == "D") { Nbrdebit++; TotalDebit += data.MONTAN; }
                                    else { NbrCrebit++; TotalCrebit += data.MONTAN; }

                                    Datat.push({
                                        key: indice,
                                        NUMCPT: data.NODUCP,
                                        DATOPE: (new Date(data.DATOPE.substring(0, 10))).toLocaleDateString("fr"),
                                        TIME: data.TIME.substring(11,),
                                        DEDEVR: (new Date(data.DEDEVR.substring(0, 10))).toLocaleDateString("fr"),
                                        SENSEC: data.SENSEC,
                                        REPECE: data.REPECE,
                                        NUMRAP: data.NUMRAP,
                                        LIBELL: data.LIBELL,
                                        MONTANT: formatNumber(data.MONTAN ? data.MONTAN : ''),
                                        MONTANTDEBIT: formatNumber(data.MONTANT ? data.MONTANT : ''),
                                        MONTANTCREDIT: formatNumber(data.MONTANT ? data.MONTANT : ''),
                                        SOLDT: formatNumber(TotalDebit + TotalCrebit),
                                        NBENEF: data.NBENEF,
                                        UTISAI: data.UTISAI
                                    });
                                })

                                setDataOperation(Datat);
                                form.setFieldValue("TotalDebit", formatNumber(TotalDebit));
                                form.setFieldValue('TotalCrebit', formatNumber(TotalCrebit));
                                form.setFieldValue("NbrCrebit", NbrCrebit);
                                form.setFieldValue("Nbrdebit", Nbrdebit);
                                form.setFieldValue("Solde", formatNumber(TotalCrebit - TotalDebit));
                                form.setFieldValue("NbrTotal", NbrCrebit + Nbrdebit);
                            }
                        }

                        Setvalide(false);
                        SetModif(false);
                        setLoading(false);
                    }
                    //  setLoad(false);
                }).catch((error) => {
                    SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
                })
    };


    const items: TabsProps['items'] = [
        {
            key: '1',
            label: (
                <span>
                    <UserOutlined />
                    Opération Temporaires
                </span>
            ),
            children: (
                <>
                    <div className='tabItem' >
                        <Box width={"85%"} position={"absolute"} className='border' sx={{ p: 1 }}>
                            {/* <Box fontStyle="inherit" className='bordure1' display={'flex'} width={'100%'} > */}
                                <Box className='bordure1'  >
                                <SearchInput notRequired form={form} width={2} Titre="Recherche Utilisateur" label="Utilisateur" name="User" handleFunction={HandleChangeUser} Parametre={searchUser} />
                               
                                </Box>
                                <Box className='bordure1' >
                                    <Form.Item labelCol={{ span: 2, offset: 0.5 }} rules={[{ required: true, message: "reference required" }]} label='Reference' name='reference'>
                                        <Select  onChange={HandlerChangReference} id='codage' size='middle' options={Operation} placeholder="Search " optionFilterProp="children" filterOption={(inputValue, option) => option!.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1 || option!.label.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1} />
                                    </Form.Item>
                                </Box>
                                
                            {/* </Box> */}
                            <Box fontStyle="inherit" className='border-left'>
                                {/* <Box  > */}
                                    {/* <Box className='bordure1' display={'flex'}  >
                                        <Typography></Typography>
                                        <Search size='middle' placeholder="Search Here" onChange={(e: any) => { SetSearchR(e.target.value.trim()); }} />
                                    </Box> */}

                                    <Box className='bordure1' display={'flex'}  >
                                    {/* <Typography></Typography> */}
                                        <Search size='middle' placeholder="Search Here" onChange={(e: any) => { SetSearchR(e.target.value.trim()); }} />

                                         </Box>
                                     <Box fontStyle="inherit" className='bordure1'>
                                        <Table size='small' style={{ marginTop: '2px' }} pagination={false} scroll={{ y: 300, x: 1200 }} columns={columns} dataSource={DataOperation} />
                              
                                     </Box>

                                 <Box className='bordure1' display={"flex"} width={"98%"} fontStyle="inherit">
                                        <Space.Compact >
                                            <Form.Item style={{ width: '85%' }} label="Total Crédit / Nbre crédit" name='TotalCrebit'><Input disabled /></Form.Item>
                                            <Form.Item style={{ width: '10%' }} name='NbrCrebit'><Input disabled /></Form.Item>
                                        </Space.Compact>
                                        <Space.Compact >
                                            <Form.Item style={{ width: '85%' }} label="Total Débit / Nbre débit" name='TotalDebit'><Input disabled /></Form.Item>
                                            <Form.Item style={{ width: '10%' }} name='Nbrdebit'><Input disabled /></Form.Item>
                                        </Space.Compact>
                                        <Space.Compact >
                                            <Form.Item style={{ width: '70%' }} label="Solde Total/Nbre" name='Solde'><Input disabled /></Form.Item>
                                            <Form.Item style={{ width: '14%' }} name='NbrTotal'><Input disabled /></Form.Item>
                                        </Space.Compact>
                                    </Box>
                                {/* </Box> */}
                            </Box>
                        </Box>
                    </div>
                </>
            )
        }
    ];


    const onFinish = async (values: any) => {
        let validation: Validation = values;
        validation.CodAge = user.codage
        validation.Codu = user.coduti;
        validation.Indice = form.getFieldValue("reference");
        validation.Motpas = Hash(validation.Motpas);
        Setvalide(true)
       setLoading(true);
        //  alert(form.getFieldValue("User"))
        if (form.getFieldValue("User") !== user.coduti) {
            if (sbmit == "V") {
                if (form.getFieldValue("TotalDebit") === form.getFieldValue("TotalCrebit")) {

                    validation.Motif = "";
                    validation.Etat = 1;
                   
                    setIsSubmit(true);
                    //let group = profilsDistant.find(()=>)
                    console.log('Received values of form: ', Crypter.encrypt(JSON.stringify("")));

                    let data = Crypter.encrypt(JSON.stringify(validation));

                    let config = {
                        method: 'post',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.ValideOperation,
                        headers: {
                            'CypherValidation': data,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        }
                    };

                    axios.request(config)
                        .then((response) => {
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                               
                                if (res.StatutCode == 200) {
                                    localStorage.clear();
                                    setIsSubmit(false);
                                    setLoading(false)
                                    SweetAlert.fire({ title: res.Message, text: res.Result, icon: "success" });
                                    setOpen(false);
                                    setDataOperation([]);
                                    formv.resetFields();
                                    HandleChangeUser();
                                    Setvalide(false)
                                    HandlerRest();

                                    setSbmit("");
                                }
                                else {
                                    formv.resetFields();
                                    formv.setFieldValue("Motpas", '');
                                    setLoading(false)
                                    SweetAlert.fire({ title: "error", text: res.Message, icon: "error" });
                                }

                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            Setvalide(false)
                            HandlerRest();
                            console.log(error)
                            SweetAlert.fire({ title: "Error", text: error, icon: "error" });
                        });

                } else {
                    Setvalide(false)
                    setLoading(false)
                    HandlerRest();
                    SweetAlert.fire({ title: "Validation Impossible écritures Déséquilibrées", text: ' Veuillez Vérifier les Opérations Saisies', icon: "error" })
                
                }
            }
            if (sbmit == "R") {

               // alert("yetoooo")
                validation.Motif = "";
                validation.Etat = 2;
                //console.log(JSON.stringify(validation));
                setIsSubmit(true);

                console.log('Received values of form: ');

                let data = Crypter.encrypt(JSON.stringify(validation));

                
                    let config = {
                        method: 'post',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.ValideOperation,
                        headers: {
                            'CypherValidation': data,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        }
                    };

                await axios.request(config)
                    .then((response) => {
                        if (response.data) {
                            //const res = JSON.parse(Crypter.decrypt(response.data));
                             const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                            if (res.StatutCode == 200) {
                                    localStorage.clear();
                                    setIsSubmit(false);
                                    setLoading(false)
                                    SweetAlert.fire({ title: res.Message, text: res.Result, icon: "success" });
                                    setOpen(false);
                                    setDataOperation([]);
                                    formv.resetFields();
                                    HandleChangeUser();
                                    Setvalide(false)
                                    HandlerRest();

                                    setSbmit("");
                                }
                                else {
                                    formv.resetFields();
                                    formv.setFieldValue("Motpas", '');
                                    setLoading(false)
                                    SweetAlert.fire({ title: "error", text: res.Message, icon: "error" });
                                }
                        }
                    })
                    .catch((error) => {
                        setLoading(false);
                        Setvalide(false)
                        HandlerRest();
                        console.log(error)
                        SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                    });
            }
        }
        else{
            SweetAlert.fire({ title: "Error", text: "impossible de valider une opération faite par vous", icon: "error" })
             setLoading(false);
              Setvalide(false);
             HandlerRest();
        }
   
    
    };


    return (
        <div>
            <div className='tab'>
                <Typography align='center' className='formTitle'><b>{window.location.pathname}</b></Typography>
                <Spin spinning={loading} tip={'En cours de traitement'} size='large' style={{ color: 'green', zIndex: 200 }} >
                    <div>
                        <Dialog
                            sx={{ zIndex: 100 }}
                            open={open}  >
                            <Form disabled={!ajoutActve} autoComplete="off" labelAlign='left' form={formv} name="dynamic_form_complex" onFinish={onFinish} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                                {ValTitle}
                                <DialogContent >
                                    <DialogContentText sx={{ height: '2em', marginTop: '1em' }}>
                                    </DialogContentText>
                                    <Form.Item label="Enter password" rules={[{ required: true, message: "password is required" }]} name="Motpas">
                                        <Input.Password />
                                    </Form.Item>
                                    {Modif}
                                </DialogContent>
                                <Divider />
                                <DialogActions  >
                                    <Button size='middle' onClick={e => { formv.setFieldValue("Motpas", ''); setOpen(false); }} disabled={Valider} block  >
                                        Annuler
                                    </Button>
                                    <Button size='middle' disabled={loading} htmlType="submit" block  >
                                        Valider
                                    </Button>
                                </DialogActions>
                            </Form>
                        </Dialog>
                    </div>
                    <Form disabled={!ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                        <div className='bG'>
                            <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
                            <Form.Item shouldUpdate className='bouttong'>
                                <Space direction="vertical" style={{ width: '100%' }}>
                                    <Button size='large' className='bt_add' disabled={false} onClick={() => { form.resetFields(); setSelectedRowKeys([]); setDataOperation([]); form.setFieldValue('etat', "E"); initialiazeButton(); }} type="ghost" htmlType="button" block  >
                                        Actualiser
                                    </Button>
                                    <Button size='large' onClick={e => { handleValide(); }} className='bt_add' disabled={Valider} type="ghost" htmlType="button" block  >
                                        Valider
                                    </Button>
                                    <Button size='large' onClick={e => { handRejet();}} className='bt_add' disabled={Valider} type="ghost" htmlType="button" block  >
                                        Rejeter
                                    </Button>
                                    <Button size='large' className='bt_add' type="ghost" htmlType="button" block  >
                                        Imprimer
                                    </Button>
                                </Space>
                            </Form.Item>
                        </div>
                        <div className='clientP'>
                            <div >
                                <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
                            </div>
                            <div>
                            </div>
                            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 200 }} open={loading} >
                                <CircularProgress color="inherit" />
                            </Backdrop>
                        </div>
                    </Form>
                </Spin>
            </div>
        </div>
    );
}
export default ValideOperation;